export default __webpack_public_path__ + "static/media/help20.57d5d3e1.png";